import type React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../utils/animations';
import Section from './ui/Section';
import SectionHeading from './ui/SectionHeading';
import Icon from './ui/Icon';
import { COMPANY_INFO } from '../utils/constants';

const ContactUs: React.FC = () => {
  // Create a URL for Google Maps that shows the address
  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(
    'г. Хабаровск, ул. Пионерская 1'
  )}&zoom=16&language=ru`;

  return (
    <Section id="contacts" bgColor="gray">
      <SectionHeading
        title="Наши контакты"
        subtitle="Свяжитесь с нами любым удобным способом"
      />

      <div className="grid gap-8 md:grid-cols-2">
        {/* Contact information */}
        <motion.div
          className="flex flex-col justify-center"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h3 className="mb-6 text-2xl font-bold text-primary">Контактная информация</h3>

          <div className="mb-8 space-y-4">
            <div className="flex items-start">
              <div className="mr-4 mt-1 rounded-full bg-primary/10 p-2 text-primary">
                <Icon name="location" size={20} />
              </div>
              <div>
                <p className="font-medium text-gray-900">Адрес офиса</p>
                <p className="text-gray-600">{COMPANY_INFO.address}</p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="mr-4 mt-1 rounded-full bg-primary/10 p-2 text-primary">
                <Icon name="phone" size={20} />
              </div>
              <div>
                <p className="font-medium text-gray-900">Телефон</p>
                <a
                  href={`tel:${COMPANY_INFO.phone}`}
                  className="text-gray-600 transition-colors hover:text-primary"
                >
                  {COMPANY_INFO.phone}
                </a>
              </div>
            </div>

            <div className="flex items-start">
              <div className="mr-4 mt-1 rounded-full bg-primary/10 p-2 text-primary">
                <Icon name="email" size={20} />
              </div>
              <div>
                <p className="font-medium text-gray-900">Email</p>
                <a
                  href={`mailto:${COMPANY_INFO.email}`}
                  className="text-gray-600 transition-colors hover:text-primary"
                >
                  {COMPANY_INFO.email}
                </a>
              </div>
            </div>

            <div className="flex items-start">
              <div className="mr-4 mt-1 rounded-full bg-primary/10 p-2 text-primary">
                <Icon name="telegram" size={20} />
              </div>
              <div>
                <p className="font-medium text-gray-900">Telegram</p>
                <a
                  href="https://t.me/Saler_ITJOY_bot"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 transition-colors hover:text-primary"
                >
                  @Saler_ITJOY_bot
                </a>
              </div>
            </div>

            <div className="flex items-start">
              <div className="mr-4 mt-1 rounded-full bg-primary/10 p-2 text-primary">
                <Icon name="clock" size={20} />
              </div>
              <div>
                <p className="font-medium text-gray-900">Режим работы</p>
                <p className="text-gray-600">{COMPANY_INFO.workingHours}</p>
              </div>
            </div>
          </div>

          {/* Social links
          <div>
            <p className="mb-3 font-medium text-gray-900">Мы в социальных сетях</p>
            <div className="flex space-x-4">
              {COMPANY_INFO.socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white transition-transform hover:scale-110"
                  aria-label={social.name}
                >
                  <Icon name={social.name.toLowerCase() as 'linkedin' | 'facebook' | 'telegram'} size={18} />
                </a>
              ))}
            </div>
          </div>*/}
        </motion.div>

        {/* Google Maps */}
        <motion.div
          className="h-80 overflow-hidden rounded-lg bg-white shadow-md md:h-auto"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <iframe
            src={mapUrl}
            width="100%"
            height="100%"
            style={{ border: 0, minHeight: '400px' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Карта расположения IT Joy"
            className="h-full w-full"
          />
        </motion.div>
      </div>
    </Section>
  );
};

export default ContactUs;
